module.exports = __webpack_public_path__ + "img/w1.99687e31.png";